module.exports = __webpack_public_path__ + "img/course.1baa604e.png";